var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIServ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "IServ_svg__a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".IServ_svg__d{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IServ_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IServ_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m.23,18.7c-.12,0-.22-.1-.22-.22V6.61c0-.12.1-.22.22-.22h.12c1.16,0,2.11.95,2.11,2.11v9.99c0,.12-.1.22-.22.22H.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m9.45,18.7c-2.19,0-4.59-1.14-4.7-3.64,0-.13.1-.23.22-.23,0,0,0,0,0,0h1.93c.11,0,.21.09.22.2.09.87,1.04,1.45,2.37,1.44,1.35,0,2.19-.57,2.19-1.48-.01-1.09-1.23-1.36-2.65-1.66-1.92-.42-4.1-.89-4.1-3.54,0-1.97,1.86-3.4,4.43-3.4,2.58,0,4.31,1.35,4.39,3.45,0,.13-.1.23-.22.23,0,0,0,0,0,0h-1.93c-.11,0-.21-.09-.22-.2-.08-.75-.93-1.28-2.07-1.28-1.14,0-1.93.56-1.93,1.37,0,.93,1.15,1.18,2.48,1.47,1.88.41,4.22.92,4.27,3.62.01.97-.29,1.77-.91,2.39-.81.82-2.16,1.27-3.78,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m21.45,18.7c-3.32,0-5.93-2.7-5.93-6.14s2.63-6.18,5.86-6.18c2.79,0,5.83,2.08,5.95,5.95,0,.32-.02.63-.05.94-.01.11-.11.2-.22.2h-8.9s-.04.01-.06.03c-.02.02-.02.04-.02.06.25,1.65,1.58,2.75,3.3,2.75,1.05,0,1.96-.38,2.64-1.11.04-.04.09-.07.15-.07l2.36.02c.08,0,.15.04.19.11.04.07.04.15,0,.23-1.06,1.98-3.08,3.21-5.28,3.21Zm0-9.93c-1.57,0-2.85.98-3.33,2.56,0,.02,0,.05.01.07.01.02.04.03.06.03h6.48s.05-.01.06-.03c.02-.02.02-.05.01-.07-.48-1.53-1.8-2.56-3.29-2.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m29.2,18.7c-.21,0-.38-.17-.38-.38v-5.15c0-4.91,3.05-6.73,5.91-6.8.13,0,.23.1.23.23v1.94c0,.12-.1.22-.22.22-2.15,0-3.45,1.65-3.47,4.41v5.15c0,.21-.17.38-.38.38h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m41.04,18.7c-.09,0-.18-.06-.21-.14l-4.61-11.86c-.05-.12.01-.25.13-.3.03-.01.06-.02.09-.02h2.08c.09,0,.18.06.21.15l3.29,8.72s.06.06.11.04c.02,0,.04-.02.04-.04l3.28-8.72c.03-.09.12-.15.22-.15h2.08c.13,0,.23.1.23.23,0,.03,0,.06-.02.09l-4.61,11.86c-.03.09-.12.15-.21.14h-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m18.44,23.61c-.68,0-1.23-.53-1.24-1.21s.53-1.23,1.21-1.24c.01,0,.02,0,.03,0h28.32c.68,0,1.23.53,1.24,1.21,0,.68-.53,1.23-1.21,1.24-.01,0-.02,0-.03,0h-28.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m12.71,23.61c-.71,0-1.24-.53-1.24-1.23s.53-1.23,1.24-1.23,1.22.54,1.22,1.23-.53,1.23-1.22,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m6.97,23.61c-.71,0-1.24-.53-1.24-1.23s.53-1.23,1.24-1.23,1.22.54,1.22,1.23-.53,1.23-1.22,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IServ_svg__d",
    d: "m1.24,23.61c-.71,0-1.24-.53-1.24-1.23s.53-1.23,1.24-1.23,1.22.54,1.22,1.23-.53,1.23-1.22,1.23Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIServ);
export default __webpack_public_path__ + "static/media/IServ.7111ffbdc7b20505dbad80fe74b29271.svg";
export { ForwardRef as ReactComponent };